import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'userFullName',
    title: 'Updated by',
    show: true
  },
  {
    isSortable: false,
    field: 'service',
    title: 'Service',
    show: true
  },
  {
    isSortable: true,
    field: 'resource',
    title: 'Action',
    show: true
  },
  {
    isSortable: true,
    field: 'action',
    title: 'Status',
    show: true
  },
  {
    isSortable: false,
    field: 'ip',
    title: 'IP'
  },
  {
    isSortable: true,
    field: 'datetime',
    title: 'Updated At',
    show: true
  },
  {
    isSortable: false,
    field: 'data',
    title: '',
    show: true
  }
];

export const defaultFilters = {
  search: '',
  userFullName: [],
  action: [],
  resource: []
};

export const defaultNavigation = {
  fieldName: 'datetime',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};
